import * as emailjs from "emailjs-com";
import {useToast} from 'vue-toastification';
const toast = useToast();
import Loading from 'vue-loading-overlay';
import {i18n} from "@/config/i18n";
export default {
    name: 'ContactPage',
    
    data() {
        return {
            isLoading: false,
            name: '',
            phone: '',
            email: '',
            service: -1,
            message: '',
            faqStates: [false, false, false],
            faqData: [
                {
                    question: i18n.global.t("contact.q1"),
                    answer: i18n.global.t("contact.a1")
                },
                {
                    question: i18n.global.t("contact.q2"),
                    answer: i18n.global.t("contact.a2")
                },
                {
                    question: i18n.global.t("contact.q3"),
                    answer: i18n.global.t("contact.a3")
                }
            ],
            socialLinks: [
                {
                    name: i18n.global.t("common.facebook"),
                    url: "https://www.facebook.com/songhancapitaldotcom",
                    icon: "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z",
                    color: "text-blue-400",
                },
                {
                    name: i18n.global.t("common.youtube"),
                    url: "https://www.youtube.com/@songhancapital",
                    icon: "M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z",
                    color: "text-red-400",
                },
            ],
            services: [
                {
                    id: 1,
                    value: "Mở tài khoản chứng khoán",
                },
                {
                    id: 2,
                    value: "Tư vấn đầu tư",
                },
                {
                    id: 3,
                    value: "Copy trade",
                },
                {
                    id: 4,
                    value: "Backcom",
                },
                {
                    id: 0,
                    value: "Khác",
                }
            ]
        }
    },

    components: {
        Loading,
    },

    mounted() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    methods: {

        checkLanguage(lang) {
            return localStorage.getItem("language") === lang;
        },

        sendMail() {
            if(this.name.trim() === '') {
                toast.error("Vui lòng nhập tên của bạn!");
                return;
            }

            if(!this.validateEmail() && !this.validatePhone()) {
                toast.error("Vui lòng nhập số điện thoại hoặc email để chúng tôi có thể liên hệ đến bạn!");
                return;
            }

            if(!this.validateEmail()) {
                this.email = "Không có email!"
            }

            if(!this.validatePhone()) {
                this.phone = "Không có số điện thoại!"
            }

            this.isLoading = true;

            const serviceID = 'service_ubjr1nn'
            const templateID = 'template_0ar5bbg'
            const userID = 'wmEczBuU0-7qG2raj'

            let serviceValue = ''

            for(let s of this.services) {
                if(s.id === this.service) {
                    serviceValue = s.value
                }
            }
            if(serviceValue === '') {
                serviceValue = "Khác"
            }

            if(this.message.trim() === '') {
                this.message = "Không có nội dung tin nhắn!"
            }
            emailjs.send(serviceID, templateID, {
                name: this.name,
                phone: this.phone,
                mail: this.email,
                service: serviceValue,
                message: this.message,
            }, userID)
                .then(response => {
                    toast.success("Thông tin của bạn đã được chúng tôi ghi nhận\nChúng tôi sẽ liên hệ đến bạn trong 24h!");
                    this.resetForm()
                    this.isLoading = false;
                })
                .catch(error => {
                    toast.error("Hệ thống chúng tôi đang có sự cố, vui lòng gửi mail đến info.songhancapital@gmail.com!");
                    this.isLoading = false;
                })

        },

        resetForm() {
            this.name = ''
            this.phone = ''
            this.email = ''
            this.service = -1
            this.message = ''
        },

        toggleFAQ(index) {
            this.faqStates[index] = !this.faqStates[index];
        },

        validateEmail() {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(this.email);
        },

        validatePhone() {
            const phoneRegex = /^(?:\+84|0)(3[2-9]|5[6|8|9]|7[0|6-9]|8[1-5]|9[0-9])[0-9]{7}$/;
            return phoneRegex.test(this.phone);
        },
    },
};
